import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Calendar as CalendarIcon } from "lucide-react";

const catColors = {
  "GST": "bg-blue-100 text-blue-700 border-blue-200 dark:bg-blue-950 dark:text-blue-300",
  "Income Tax": "bg-violet-100 text-violet-700 border-violet-200 dark:bg-violet-950 dark:text-violet-300",
  "TDS": "bg-emerald-100 text-emerald-700 border-emerald-200 dark:bg-emerald-950 dark:text-emerald-300",
  "ROC": "bg-amber-100 text-amber-700 border-amber-200 dark:bg-amber-950 dark:text-amber-300",
  "LLP": "bg-rose-100 text-rose-700 border-rose-200 dark:bg-rose-950 dark:text-rose-300",
  "Others": "bg-slate-100 text-slate-700 border-slate-200 dark:bg-slate-800 dark:text-slate-200",
};

export default function Calendar() {
  const [items, setItems] = useState([]);

  useEffect(() => { api.get("/duedates/calendar").then(({ data }) => setItems(data)); }, []);

  const grouped = items.reduce((acc, it) => {
    acc[it.category] = acc[it.category] || [];
    acc[it.category].push(it);
    return acc;
  }, {});

  return (
    <div className="space-y-5" data-testid="calendar-page">
      <div>
        <div className="text-[10px] uppercase tracking-widest text-muted-foreground flex items-center gap-1.5">
          <CalendarIcon className="w-3 h-3" /> Statutory · India
        </div>
        <h1 className="font-display text-3xl font-bold tracking-tight mt-1">Compliance Calendar</h1>
        <p className="text-sm text-muted-foreground mt-1">Standard due dates across GST, Income Tax, TDS, ROC and other filings.</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {Object.entries(grouped).map(([cat, list]) => (
          <Card key={cat} className="p-5">
            <div className="flex items-center justify-between mb-4">
              <h3 className="font-display font-semibold">{cat}</h3>
              <Badge className={catColors[cat]}>{list.length} forms</Badge>
            </div>
            <div className="space-y-2">
              {list.map((it) => (
                <div key={`${it.form}-${it.due_day}`} className="flex items-center gap-3 py-2 border-b border-border last:border-0" data-testid={`calendar-item-${it.form}`}>
                  <div className="w-12 h-12 rounded-md bg-slate-100 dark:bg-zinc-900 grid place-items-center font-display">
                    <div className="text-[8px] text-muted-foreground uppercase leading-none">Day</div>
                    <div className="font-mono font-bold text-lg leading-none">{it.due_day}</div>
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="text-sm font-semibold">{it.form}</div>
                    <div className="text-[11px] text-muted-foreground">{it.description}</div>
                  </div>
                  <Badge variant="outline" className="text-[10px]">{it.frequency}</Badge>
                </div>
              ))}
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
}
